import * as React from "react";
import PageNavigation from "components/common/PageNavigation";
import { Row } from "components/bootstrap";
import { PageHeader, DocumentTitle } from "components/common";
import { PAGE_NAV_TITLE } from "components/lookup-tables/bindings";
function LUTLayout({
  documentTitle = void 0,
  pageTitle = void 0,
  pageDescription = void 0,
  actions = null,
  children
}) {
  return /* @__PURE__ */ React.createElement(DocumentTitle, { title: documentTitle }, /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(PageNavigation, { page: PAGE_NAV_TITLE })), /* @__PURE__ */ React.createElement(PageHeader, { title: pageTitle, actions }, /* @__PURE__ */ React.createElement("span", null, pageDescription)), children);
}
export default LUTLayout;
